export const AMPLITUDE_PRODUCT_CLICKED = 'product_clicked' as const;
export const AMPLITUDE_MODULE_CLICKED = 'module_click' as const;
export const AMPLITUDE_PRODUCT_FAVORITES_ADD = 'favorite_add' as const;
export const AMPLITUDE_FILTER_ADDED = 'filter_added' as const;
export const AMPLITUDE_FILTER_REMOVED = 'filter_removed' as const;

export const AMPLITUDE_PRODUCT_CLICKED_EVENT_ID = 70 as const;
export const AMPLITUDE_PRODUCT_FAVORITES_ADD_EVENT_ID = 70 as const;
export const AMPLITUDE_FILTER_EVENT_ID = 7 as const;

export const GTM_EVENT_KEY = 'gtm.uniqueEventId' as const;

// Generic Amplitude event types
export const AMPLITUDE_EVENT_TYPES = [
  'click',
  'impression',
  'hover'
  // add more event types as needed
] as const;

// Screen types for Amplitude tracking - different from Amethyst PAGE_TYPE_MAP
export const AMPLITUDE_SCREEN_TYPES = {
  // Shopping & Browse
  'search': 'plp',
  'searchByImage': 'search_by_image',
  'pdp': 'pdp',
  'landing': 'landing',
  'brand': 'brand',
  'homepage': 'homepage',

  // Cart & Checkout
  'cart': 'cart',
  'checkout': 'checkout',
  'confirmation': 'confirmation',

  // Account & Orders
  'account': 'account',
  'orders': 'orders',
  'orderInformation': 'order_details',
  'my-orders': 'my_orders',

  // Favorites & Collections
  'favorites': 'favorites',
  'collection': 'collection',

  // Returns & Exchanges
  'returns': 'returns',
  'my-returns': 'my_returns',
  'return-item': 'return_item',
  'return-info': 'return_info',
  'exchanges': 'exchanges',

  // Account Management
  'address': 'address',
  'payment': 'payment',
  'subscriptions': 'subscriptions',

  // Reviews & Images
  'reviews': 'reviews',
  'images': 'images',

  // Rewards & VIP
  'rewards': 'rewards',

  // Other
  'login': 'login',
  'zap': 'zap',
  'hmd': 'hmd',
  'shipments': 'shipments',
  'livechat': 'livechat',
  'egc': 'egc',
  'createlabel': 'create_label',
  'outfit': 'outfit',
  'item-details': 'item_details'
} as const;
